var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classnames from 'classnames';
import styles from './style.module.less';
var ImageLoad = (function (_super) {
    __extends(ImageLoad, _super);
    function ImageLoad(props) {
        var _this = _super.call(this, props) || this;
        _this.onImageLoad = function () {
            _this.setState({
                loaded: true
            });
        };
        _this.state = {
            loaded: false
        };
        return _this;
    }
    ImageLoad.prototype.render = function () {
        var _a;
        var _b = this.props, source = _b.source, style = _b.style, className = _b.className;
        var loaded = this.state.loaded;
        return (_jsxs("div", { className: classnames(styles["image-load"], className), style: style, children: [_jsx("img", { src: source, onLoad: this.onImageLoad, style: { opacity: loaded ? 1 : 0 } }), _jsx("i", { className: classnames(styles.ripple, (_a = {},
                        _a[styles["ripple-hide"]] = loaded,
                        _a)) })] }));
    };
    return ImageLoad;
}(React.Component));
export default ImageLoad;
